import { catalog } from '../core/catalog.js';
import { t } from '../core/i18n.js';
import { device } from '../core/device.js';
import { tvnav } from '../core/tvnav.js';
import { escapeHtml } from '../core/utils.js';
import { movieCard, seriesCard, enhance } from '../ui/render.js';

/* Ventana de una colección de Jellyfin, Emby o Plex: sus títulos en una cuadrícula (se abren como en cualquier otra pantalla). */

export function openCollection(key) {
    const col = catalog.collections().find((c) => c.key === key);
    if (!col) return null;
    const app = window.app;
    const id = 'coll-' + Date.now().toString(36);
    const popup = app.popup.create({
        content: `<div class="popup catpick-popup admin-popup" id="${id}">
            <div class="page">
                <div class="navbar"><div class="navbar-bg"></div><div class="navbar-inner">
                    <div class="title">${escapeHtml(col.name)}</div>
                    <div class="right"><a href="#" class="link popup-close btn-icon" aria-label="${t('common.close')}"><span class="mi">close</span></a></div>
                </div></div>
                <div class="page-content"><div class="grid" data-grid style="padding:var(--sp-4)">${col.items.map((m) => (m.kind === 'vod' ? movieCard(m.item) : seriesCard(m.item))).join('')}</div></div>
            </div>
        </div>`,
        on: {
            open(p) {
                const el = p.el || document.getElementById(id);
                enhance(el);
                // Al abrir un título, la ventana se cierra para que la ficha se vea.
                el.addEventListener('click', (e) => { if (e.target.closest('[data-open]')) popup.close(); }, true);
            },
            opened(p) {
                if (device.isTV) tvnav.focusLayer(p.el);
            },
            closed() {
                try { popup.destroy(); } catch (e) { /* ya destruido */ }
                const el = document.getElementById(id);
                if (el && el.parentNode) el.parentNode.removeChild(el);
            }
        }
    });
    popup.open();
    return popup;
}
